
import { getQueryStringValue, setQueryStringValue } from "./queryParamsHelper";

const availableQueryFilterKeys: string[] = [
  "invoiceId",
];

export function setQueryFilter(filters: Record<string, unknown>) {
  setQueryStringValue("filters", filterObject(filters, availableQueryFilterKeys));
}

export function getQueryFilter(): Record<string, unknown> {
  return filterObject(getQueryStringValue("filters", {}), availableQueryFilterKeys);
}

function filterObject(object: Record<string, unknown>, keys: string[]): Record<string, unknown> {
  return Object.keys(object).reduce((acc: Record<string, unknown>, key: string): Record<string, unknown> => {
    const isValue: boolean = Boolean(object[key]) || object[key] === 0 || object[key] === false;
    if (keys.includes(key) && isValue) {
      return {
        ...acc,
        [key]: object[key],
      };
    }
    return acc;
  }, {});
}
